import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import headerLogo from '../assets/img/logo-amerinode.jpeg'
import { Context } from '../context/UserContext'
import api from '../utils/api';
import { FaRegQuestionCircle } from "react-icons/fa";



export default function Header() {

  const { authenticated, logout, user, setUser } = useContext(Context)
  const [token] = useState(localStorage.getItem("token") || "");

  const navigate = useNavigate();

  // Pegando a cor do header da variável de ambiente
  const headerColor = process.env.REACT_APP_HEADER_COLOR || '#0F172A';

  useEffect(() => {
    if (authenticated) {
      api
        .get("/users/checkuser", {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        })
        .then((response) => {
          setUser(response.data);
          // console.log(response.data);
        });
      // console.log(user);
    }
  }, [token, setUser, authenticated]);


  return (
    <div className='w-full h-full flex-col sm:flex relative justify-center items-center' style={{ backgroundColor: headerColor }}>
      <div className='flex'>
          <img
            className="mx-auto h-3 sm:h-4 w-auto my-2 sm:my-1"
            src={headerLogo}
            alt="Your Company"
          />
      </div>
      <div className='flex justify-end sm:absolute right-24'>
        <div className="items-center gap-2 inline-flex h-full">
            <div className="text-right w-max">
                <span className="text-white text-base font-medium">Olá, </span>
                <span className="text-white text-base font-semibold">{user?.name}</span>
            </div>
            <div className="justify-end items-center flex">
                <button className="w-8 h-8 justify-center items-center flex" onClick={()=>navigate('/app/profile')}>
                    {/* <img
                        className="rounded-full"
                        src="https://i.pravatar.cc/300"
                        alt="avatar"
                    /> */}
                    <div className="bg-white justify-center items-center flex rounded-full">
                      <img
                        src={ user.image 
                          ? `${process.env.REACT_APP_API}/images/users/${user?.image}`
                          : `${process.env.REACT_APP_API}/images/users/user.jpg`
                        
                      }
                        alt={user.name}
                        className="h-8 w-8 object-cover rounded-full"
                      />
                      </div>
                </button>
                { authenticated && (
                  <button className='text-sm text-white mx-4 hover:font-semibold' onClick={logout}>Sair</button>
                ) 
                }
            </div>
          <button className='text-white hidden sm:block'>
            <Link to="/app/help">
              <FaRegQuestionCircle size={19} />
            </Link>
          </button>
        </div>
      </div>
    </div>
  )
}
